import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from 'Services/Services';
import { FaEdit, FaTrash } from 'react-icons/fa';

import { FaEye } from "react-icons/fa6";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function ToppingView() {
  const [toppings, setToppings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const pageSize = 5;

  const fetchToppings = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/topping`); // Update to your API URL
      setToppings(res.data.data || []);
    } catch (err) {
      console.error('Error fetching toppings', err);
    }
  };

  useEffect(() => {
    fetchToppings();
  }, []);

  const pageCount = Math.ceil(toppings.length / pageSize);
  const paginatedData = toppings.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const nextPage = () => {
    if (currentPage < pageCount) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleEdit = async(id) =>{
    navigate(`/admin/editTopping/${id}`);
  }

   const handleDelete = async(id)=>{
    try {
        const response = await axios.delete(`${ApiUrl}/topping/${id}`)
        console.log(response);
        fetchToppings()
        toast.success("Topping Deleted")
    } catch (error) {
        console.log(error)
    }
   }
  return (
    <div className="max-w-6xl mx-auto mt-8 p-6  rounded-lg">
      <div className="flex justify-end items-center mb-6">
        <button
        onClick={()=>{navigate('/admin/addTopping')}}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          + Add Topping
        </button>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="py-2 px-4 border-b">Image</th>
              <th className="py-2 px-4 border-b">Name</th>
              <th className="py-2 px-4 border-b">Price</th>
              <th className="py-2 px-4 border-b">Categories</th>
              <th className="py-2 px-4 border-b">Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((topping) => (
              <tr key={topping.id} className="hover:bg-gray-50">
                <td className="py-2 px-4 border-b">
                  <img
                    src={topping.image?.startsWith('http') ? topping.image : `http://localhost:5000/uploads/${topping.image}`}
                    alt={topping.name}
                    className="w-12 h-12 object-cover rounded"
                  />
                </td>
                <td className="py-2 px-4 border-b">{topping.name}</td>
                <td className="py-2 px-4 border-b">Rs. {topping.price}</td>
                <td className="py-2 px-4 border-b">
                  {topping.categories.map((cat) => cat.title).join(', ')}
                </td>
                <td className="px-4 py-3 text-right space-x-2">
                                  {/* <button
                                    // onClick={() => handelView(food.id)}
                                    className="text-blue-500 hover:text-blue-700"
                                  >
                                    <FaEye />
                                  </button> */}
                                  <button
                                    onClick={() => handleEdit(topping.id)}
                                    className="text-blue-500 hover:text-blue-700"
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    onClick={() => handleDelete(topping.id)}
                                    className="text-red-500 hover:text-red-700"
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
              </tr>
            ))}

            {paginatedData.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  No toppings found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={prevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Previous
        </button>

        <span className="text-gray-600">
          Page {currentPage} of {pageCount}
        </span>

        <button
          onClick={nextPage}
          disabled={currentPage === pageCount}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default ToppingView;
